module.exports = __webpack_public_path__ + "img/unifg-branco.30aba097.svg";